import { companyClient } from "api/api";

export const getAppointmentChecklists = async (appointmentId: number) => {
  return companyClient({
    method: "GET",
    url: `/appointment-checklists/${appointmentId}`,
  });
};
